import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { ApiService } from '../api.service'
import Swal from 'sweetalert2'

@Component({
	selector: 'logs',
	templateUrl: './logs.component.html',
	styleUrls: ['./logs.component.scss']
})

export class LogsComponent implements OnInit, OnDestroy {

	events: any[] = []
	event = ''

	users: any[] = []
	user = 0

	start = ''
	end = ''

	logs: any[] = []

	state: 'idle' | 'loading' | 'error' = 'idle'

	getEventsSub = new Subscription
	getUsersSub = new Subscription
	getLogsSub = new Subscription

	constructor(private dataService: ApiService) {}

	ngOnInit(): void {
		this.getEventsSub = this.dataService.getEvents()
		.subscribe({
			next: (events) => {
				console.log(events)
				this.events = events
			},
			error: (e) => {
				console.log(e)
			},
		})

		this.getUsersSub = this.dataService.getUsers()
		.subscribe({
			next: (users) => {
				console.log(users)
				this.users = users
			},
			error: (e) => {
				console.log(e)
			}
		})
	}

	ngOnDestroy(): void {
		this.getEventsSub?.unsubscribe()
		this.getUsersSub?.unsubscribe()
		this.getLogsSub?.unsubscribe()
	}

	getLogs() {
		this.logs = []
		
		if (this.event == '' && this.user == 0 && this.start == '' && this.end == '') {
			Swal.fire('Error', 'Por favor seleccione un filtro.', 'error')
			return
		}
		
		this.state = 'loading'
		this.getLogsSub = this.dataService.getLogs(this.event, this.user, this.start, this.end)
		.subscribe({
			next: (logs) => {
				console.log(logs)
				this.state = 'idle'
				this.logs = logs
			},
			error: (e) => {
				console.log(e)
				this.state = 'error'
			},
		})
	}

}
